<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <div class="col-sm-12">
            <label v-if="(bahasa === null) || (bahasa == 'ina')">Saran untuk MIS </label>
            <label v-else>Suggestions for MIS</label>
            <div class="row">
                <div class="col-sm-12">
                    <quill-editor v-model:value="saran" style="height: 55vh;background-color: #ffffff;"></quill-editor>
                </div>
            </div>
        </div>
        <div class="col-sm-6 float-left pb-2 wow fadeInDown">
            <label v-if="(bahasa === null) || (bahasa == 'ina')">Kode Keamanan</label>
            <label v-else>Captcha</label>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                </div>
                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                    placeholder="Kode Keamanan" v-model="capcha" disabled>
            </div>
        </div>
        <div class="col-sm-6 float-left pb-2 wow fadeInDown">
            <label v-if="(bahasa === null) || (bahasa == 'ina')">Ulangi Kode Keamanan</label>
            <label v-else>Repeat Captcha</label>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                </div>
                <input type="text" class="form-control form-control-sm" id="capchainput" name="capchainput"
                    placeholder="" v-model="capchainput" style="text-transform:uppercase">
            </div>
        </div>
        <div class="lockscreen-item" style="background: transparent;">
            <div class="input-group">
                <div class="custom-control custom-switch custom-switch-on-primary">
                    <input type="checkbox" class="custom-control-input" id="customSwitchAuth">
                    <label class="custom-control-label" for="customSwitchAuth" @click="rubahisi()"
                        style="font-size: small;">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Autentikasi Pengguna Manusia</span>
                        <span v-else>Human User Authentication</span>
                    </label>
                </div>
            </div>
            <div class="help-block text-center">&nbsp;</div>
            <button class="btn btn-danger2 btn-block text-white" placeholder="Kirim" data-toggle="tooltip"
                data-placement="left" title="Kirim aduan.." style="color: black;" v-on:click="aduanAct"
                :disabled="showHuman == false" v-if="(bahasa === null) || (bahasa == 'ina')">
                <b><i class="fas fa-mail-bulk"></i>
                    Kirim
                </b>
            </button>
            <button class="btn btn-danger2 btn-block text-white" placeholder="Kirim" data-toggle="tooltip"
                data-placement="left" title="Kirim aduan.." style="color: black;" v-on:click="aduanAct"
                :disabled="showHuman == false" v-else>
                <b><i class="fas fa-mail-bulk"></i>
                    Send
                </b>
            </button>
        </div>
        <!-- /.lockscreen-item -->
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">SARAN DAN MASUKAN</span>
                <span v-else>SUGGESTIONS AND FEEDBACK</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Saran Dan Masukan</span>
                    <span v-else>Suggestions And Feedback</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <div class="section-title mb-2 wow fadeInDown" data-wow-delay="0.1s">
            <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                    <h1 v-if="(bahasa === null) || (bahasa == 'ina')" class="text-danger m-0 pmisdanger"
                        style="font-size: x-large;">BAGAIMANA PENDAPAT SAUDARA / SAUDARI MENGENAI LAYANAN MIS NUFReP?
                    </h1>
                    <h1 v-else class="text-danger m-0 pmisdanger" style="font-size: x-large;">WHAT DO YOU THINK ABOUT
                        NUFReP MIS SERVICES?</h1>
                    <span v-if="(bahasa === null) || (bahasa == 'ina')"> Silahkan pilih dengan menekan pilihan dibawah,
                        terimakasih
                    </span>
                    <span v-else>Please choose by pressing the option below, thank you</span>
                </div>
                <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">&nbsp;</div>
                <div class="row g-4 justify-content-center">
                    <div class="col-md-4 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s"
                        style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                        <div class="blog-item rounded">
                            <div class="blog-img">
                                <img src="../../../../src/assets/img/tidakpuas.png" class="img-fluid w-50" height="60"
                                    alt="Tidak Puas" style="cursor:pointer" data-toggle="tooltip"
                                    data-placement="bottom" title="Tidak Puas.." @click="pilih('Tidak Puas')">
                            </div>
                            <div class="blog-centent p-4">
                                <a href="javascript:void(0)" class="pmisjudulberita" data-toggle="tooltip"
                                    data-placement="bottom" title="Tidak Puas.." @click="pilih('Tidak Puas')">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tidak Puas
                                    </span>
                                    <span v-else>
                                        Not satisfied
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s"
                        style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                        <div class="blog-item rounded">
                            <div class="blog-img">
                                <img src="../../../../src/assets/img/biasa.png" class="img-fluid w-50" height="60"
                                    alt="Biasa" style="cursor:pointer" data-toggle="tooltip" data-placement="bottom"
                                    title="Biasa.." @click="pilih('Biasa')">
                            </div>
                            <div class="blog-centent p-4">
                                <a href="javascript:void(0)" class="pmisjudulberita" data-toggle="tooltip"
                                    data-placement="bottom" title="Biasa.." @click="pilih('Biasa')">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Biasa
                                    </span>
                                    <span v-else>
                                        Normal
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s"
                        style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                        <div class="blog-item rounded">
                            <div class="blog-img">
                                <img src="../../../../src/assets/img/puas.png" class="img-fluid w-50" height="60"
                                    alt="Puas" style="cursor:pointer" data-toggle="tooltip" data-placement="bottom"
                                    title="Puas.." @click="pilih('Puas')">
                            </div>
                            <div class="blog-centent p-4">
                                <a href="javascript:void(0)" class="pmisjudulberita" data-toggle="tooltip"
                                    data-placement="bottom" title="Puas.." @click="pilih('Puas')">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Puas
                                    </span>
                                    <span v-else>
                                        Satisfied
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-2 wow fadeInDown" data-wow-delay="0.1s">
                <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                    &nbsp;
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->
    
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import { quillEditor } from 'vue3-quill';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            pilihan: '',
            saran: '',
            showHuman: false,
            capcha: this.makeid(5),
            capchainput: "",
            project_id: process.env.VUE_APP_PROJECT_ID,
            linknya: process.env.VUE_APP_URL_API,
        };
    },
    methods: {
        pilih(isian) {
            this.pilihan = isian;
            var modal = document.getElementById("myModal");
            // Get the image and insert it inside the modal - use its "alt" text as a caption
            modal.style.display = "block";

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close")[0];

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }
        },
        rubahisi() {
            if (this.showHuman == false) {
                this.showHuman = true;
            }
            else {
                this.showHuman = false;
            }
        },
        async aduanAct() {
            if (this.pilihan == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Silahkan pilih tingkat kepuasan MIS..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
            }

            if (this.capchainput == "") {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                document.getElementById("capchainput").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
            }
            if (this.capchainput.toUpperCase() != this.capcha) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Kode Keamanan Tidak Sama..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                document.getElementById("capchainput").focus();
                this.showHuman = false;
                document.getElementById('customSwitchAuth').checked = false;
                return false;
            }

            const data = {
                pilihan: this.pilihan,
                saran: this.saran,
                project_id: this.project_id,
            };

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovationSaran-saran", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.showHuman = false;
                        document.getElementById('customSwitchAuth').checked = false;
                        return false;

                    }
                    else {
                        swal.fire('Informasi', Response.data.message, 'success').then(function () {
                            window.location.replace("/");
                        });
                        $('.swal2-container').css("z-index", '999999');

                        return false;
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    document.getElementById('customSwitchAuth').checked = false;
                    this.showHuman = false;
                    return false;
                }
            )
        },
    },
    mounted() {
        this.halamanloading = false;
    },
}
</script>

<style>
/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 1);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 1);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 100%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 100%;
    max-width: 100%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>